import {IconProps, darkGray, gray, white, yellow} from './shared';

export const Okay = ({selected}: IconProps) => {
  const backgroundColor = selected ? yellow : gray;
  const foregroundColor = selected ? darkGray : white;
  const backgroundOpacity = selected ? '1.0' : '0.7';

  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M40 20C40 31.0457 31.0457 40 20 40C8.9543 40 0 31.0457 0 20C0 8.9543 8.9543 0 20 0C31.0457 0 40 8.9543 40 20Z"
        fill={backgroundColor}
        opacity={backgroundOpacity}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.6522 28.387C11.6522 27.6966 12.2119 27.137 12.9022 27.137V29.637C12.2119 29.637 11.6522 29.0774 11.6522 28.387ZM27.0957 29.637L12.9022 29.637V27.137L27.095 27.137L27.0957 29.637ZM27.0957 29.637C27.7861 29.637 28.3458 29.0774 28.3458 28.387C28.3458 27.6966 27.7854 27.137 27.095 27.137L27.0957 29.637Z"
        fill={foregroundColor}
      />
      <path
        d="M15.4829 14.8386C15.4829 16.6202 14.0386 18.0644 12.2571 18.0644C10.4755 18.0644 9.03125 16.6202 9.03125 14.8386C9.03125 13.057 10.4755 11.6128 12.2571 11.6128C14.0386 11.6128 15.4829 13.057 15.4829 14.8386Z"
        fill={foregroundColor}
      />
      <path
        d="M30.9667 14.8386C30.9667 16.6202 29.5225 18.0644 27.7409 18.0644C25.9594 18.0644 24.5151 16.6202 24.5151 14.8386C24.5151 13.057 25.9594 11.6128 27.7409 11.6128C29.5225 11.6128 30.9667 13.057 30.9667 14.8386Z"
        fill={foregroundColor}
      />
    </svg>
  );
};
